import { createContext } from 'react';
import { FormInstance } from 'antd';

interface ISpaces {
  spaceId: String;
  name: String
}

export const SpaceContext = createContext<ISpaces[] | null>(null);

export const DetailFormContext = createContext<FormInstance<any> | null>(null);